import { render, staticRenderFns } from "./comp_ShopSortSelect.vue?vue&type=template&id=fcc19c7a&scoped=true&"
import script from "./comp_ShopSortSelect.vue?vue&type=script&lang=js&"
export * from "./comp_ShopSortSelect.vue?vue&type=script&lang=js&"
import style0 from "./comp_ShopSortSelect.vue?vue&type=style&index=0&id=fcc19c7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc19c7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
